/**
* set Cookie
* @param String name
* @param Mixed value
* @param Int days - number of days
* @param String path
* @returns Boolean
**/
export const setCookie = (name, value, days, path) => {
  let expires = ""
  if (days) {
    let date = new Date()
    date.setTime(date.getTime() + (days*24*60*60*1000))
    expires = "; expires=" + date.toGMTString()
  }
  path = path ? path : "/"
  document.cookie = name + "=" + value + expires + "; path=" + path 
  return true
}

/**
* get Cookie
* @param String name
* @returns Mixed
**/
export const getCookie = (name) => {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');
  for(let i=0;i < ca.length;i++) {
      let c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}


/**
* unset Cookie
* @param String name
* @returns Mixed
**/
export const unsetCookie = (name, path) => {
  path = path ? path : "/"
  setCookie(name, "", -1, path)
}

